<template>
    <div class="card">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <span class="fs-3"><i class="bi bi-play-btn me-2"></i> みんなの作品</span>
            <div v-if="school_classes.length > 1">
                <form-select
                    v-model="school_class_id"
                    :options="school_classes"
                    @change="search()"
                ></form-select>
            </div>
        </div>

        <div class="card-body">
            <template v-if="loading">
                <inline-loader message="読込中・・・" size="md"></inline-loader>
            </template>
            <template v-else>
                <div class="mb-2">
                    <form-select
                        v-model="filter_theme"
                        :options="themes"
                        option_key="theme_id"
                        option_label="theme_name"
                        empty_option="全て"
                    ></form-select>
                </div>
                <div v-if="colorings.length > 0" class="row g-2">
                    <template v-for="coloring in colorings" :key="coloring.coloring_id">
                    <transition name="fade">
                    <div class="col-8" v-if="filter_theme === null || filter_theme == coloring.theme.theme_id">
                        <div class="coloring-list-item" @click="modal_coloring = coloring">
                            <div class="coloring-list-thumbnail">
                                <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 501 501"
                                    width="500"
                                    height="500"
                                    v-html="coloring.svg"
                                ></svg>
                            </div>
                            <h5 class="coloring-list-subtitle">{{ coloring.theme.theme_name }}</h5>
                            <h5 class="coloring-list-title">{{ coloring.coloring_title }}</h5>
                        </div>
                    </div>
                    </transition>
                    </template>
                </div>
                <alert-no-record v-else text="作品がまだありません"></alert-no-record>
            </template>
        </div>
    </div>

    <transition name="fade">
        <div v-if="modal_coloring !== null">
            <div class="modal-backdrop show"></div>
            <div class="modal" tabindex="-1" style="display:block">
                <div class="modal-dialog" style="max-width: 95%">
                    <div class="modal-content">
                        <div class="modal-header py-1">
                            <h4 class="modal-title">{{ modal_coloring.coloring_title }}</h4>
                            <button type="button" class="btn-close" @click="modal_coloring = null"></button>
                        </div>
                        <div class="modal-body p-1">
                            <figure class="zoom">
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 501 501"
                                width="500"
                                height="500"
                                v-html="modal_coloring.svg"
                                class="zoom-svg"
                            ></svg>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import AlertNoRecord from '@/shared/components/design/AlertNoRecord';
import FormSelect from '@/shared/components/form/FormSelect';
import InlineLoader from '../../shared/components/tool/InlineLoader.vue';
import Coloring from '../../shared/models/entities/kumiiro/coloring.js';
import SchoolClass from '../../shared/models/entities/school-class.js';
import Theme from '../../shared/models/entities/kumiiro/theme';

export default {
    name: 'PageColoringList',
    components: {
        AlertNoRecord,
        InlineLoader,
        FormSelect,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            colorings: [],
            loading: false,
            school_classes: [],
            themes: [],
            filter_theme: null,
            school_class_id: this.$store.state.kumiiro.auth.school_class.school_class_id,
            modal_coloring: null,
        }
    },
    mounted() {
        this.search();
        this.$http.get(`/kumiiro/school-class`)
        .then(response => {
            for(let row of response.data) {
                var school_class = new SchoolClass(row);
                this.school_classes.push({key: school_class.school_class_id, label: school_class.class_name_display});
            }
        });
    },
    methods: {
        search() {
            this.colorings = new Array;
            this.loading = true;
            this.$http.get('/kumiiro/coloring', {params: {school_class: this.school_class_id}})
            .then(response => {
                let theme_ids = []; //重複チェック用
                this.themes = [];
                for (let row of response.data) {
                    this.colorings.push(new Coloring(row));
                    if (theme_ids.indexOf(row.theme.theme_id) === -1) {
                        this.themes.push(new Theme(row.theme));
                        theme_ids.push(row.theme.theme_id);
                    }
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
    },
}
</script>

<style scoped>
.coloring-list-item {background: #EEEEF7; padding: 0.1rem;}
.coloring-list-item a {text-decoration: none; color: #002;}
.coloring-list-thumbnail {position: relative; width: 100%; height: 0; padding-top: 100%; background: #FFFFFF;}
.coloring-list-thumbnail svg {position: absolute; left: 0; top: 0; width: 100%; height: 100%;}
.coloring-list-nowprinting {position: relative; width: 100%; height: 0; padding-top: 75%; background: #DDDDEE;}
.coloring-list-nowprinting i {position: absolute; left: 0; right: 0; top: 0; bottom: 0; width: 4rem; height: 4rem; margin: auto; color: #FFF; font-size: 4rem;}
.coloring-list-nowprinting i::before {vertical-align: top;}
.coloring-list-subtitle {width: 100%; margin-bottom: 0; padding: 0.2rem 0.2rem 0; font-size: 0.6rem; color: #666; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
.coloring-list-title {width: 100%; margin-bottom: 0; padding: 0.2rem; font-size: 0.8rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
.zoom {width: 100%; height: calc(100vh - 6rem); margin-bottom: 0;}
.zoom svg {width: 100%; height: 100%; object-fit: contain;}
</style>
